// extracted by mini-css-extract-plugin
export default {"formContainer":"debit-note-form_formContainer__zB1iy","currencyDropdown":"debit-note-form_currencyDropdown__uesct"};